<template>
  <div class="flex-container">
    <div class="widget-container" v-if="isStandardOrLawUser">
      <AlertsWidget></AlertsWidget>
    </div>
    <div class="widget-container" v-if="isStandardUser">
      <AnnouncementsWidget></AnnouncementsWidget>
    </div>
    <div class="widget-container" v-if="isStandardUser">
      <SchedulesAndBellsWidget></SchedulesAndBellsWidget>
    </div>
    <div class="widget-container" v-if="isStandardUser">
      <ScheduledAnnouncementWidget></ScheduledAnnouncementWidget>
    </div>
    <div class="widget-container" v-if="isStandardUser && machine_type === 'Box' && feature_text_notification_widget_enabled">
      <TextBasedNotificationWidget></TextBasedNotificationWidget>
    </div>
    <div class="widget-container" v-if="isStandardUser">
      <ZonesAndDevicesWidget></ZonesAndDevicesWidget>
    </div>
    <div class="widget-container">
      <NotepadWidget />
    </div>    
    <div class="widget-container">
      <ClockWidget />
    </div>
    <div class="widget-container">
      <TimerWidget />
    </div>
    <div class="widget-container">
      <CalculatorWidget />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertsWidget from '../components/Widgets/AlertsWidget/AlertsWidget.vue';
import AnnouncementsWidget from '../components/Widgets/AnnouncementsWidget/AnnouncementsWidget.vue';
import ZonesAndDevicesWidget from '../components/Widgets/ZonesAndDevicesWidget/ZonesAndDevicesWidget.vue';
import SchedulesAndBellsWidget from '../components/Widgets/SchedulesAndBellsWidget/SchedulesAndBellsWidget.vue';
import TextBasedNotificationWidget from '../components/Widgets/TextBasedNotificationWidget/TextBasedNotificationWidget.vue';
import ScheduledAnnouncementWidget from '../components/Widgets/ScheduledAnnouncementWidget/ScheduledAnnouncementWidget.vue';
import CalculatorWidget from '../components/Widgets/CalculatorWidget/CalculatorWidget.vue';
import TimerWidget from '../components/Widgets/TimerWidget/TimerWidget.vue';
import NotepadWidget from '../components/Widgets/NotesWidget/NotepadWidget.vue';
import ClockWidget from '../components/Widgets/ClockWidget/ClockWidget.vue';
import router from '../router'

export default {
  name: 'home',
  components: { AlertsWidget, AnnouncementsWidget, SchedulesAndBellsWidget, ZonesAndDevicesWidget, TextBasedNotificationWidget, ScheduledAnnouncementWidget, CalculatorWidget, TimerWidget, NotepadWidget, ClockWidget},
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      logged_in_user: 'loggedInUser',
      is_active_alert_event: 'isActiveAlertEvent',
      active_alert_chat_enabled: 'activeAlertChatEnabled',
      feature_g2_secure_enabled: 'featureG2SecureEnabled',
      feature_text_notification_widget_enabled: 'featureTextNotificationWidgetEnabled',
      machine_type: 'machineType'
    }),
    isStandardUser: function () {
      return this.is_authenticated && [1,2,3,4].includes(this.logged_in_user.group_id)
    },
    isStandardOrLawUser: function () {
      return this.is_authenticated && [1,2,3,4,7].includes(this.logged_in_user.group_id)
    }
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')

    if (this.is_active_alert_event && this.feature_g2_secure_enabled && this.active_alert_chat_enabled) {
      router.push({ name: 'AlertDashboard' })
    }
  }
}
</script>


<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.widget-container {
}
</style>